import React from 'react'
import { useNavigate } from 'react-router-dom'
import { motion } from 'framer-motion'
import {
  User,
  Mail,
  Building2,
  LogOut,
  ChevronRight,
  Shield,
  Bell,
  HelpCircle
} from 'lucide-react'
import { useAuth } from '../App'
import Header from '../components/Header'
import BottomNav from '../components/BottomNav'

const Profile: React.FC = () => {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  const menuItems = [
    {
      icon: Shield,
      label: 'Privacy & Security',
      action: () => alert('Feature coming soon'),
    },
    {
      icon: Bell,
      label: 'Notifications',
      action: () => alert('Feature coming soon'),
    },
    {
      icon: HelpCircle,
      label: 'Help & Support',
      action: () => alert('Contact your operator for support'),
    },
  ]

  return (
    <div className="min-h-screen bg-gray-100 pb-safe">
      <Header title="Profile" showLogout={false} />

      <div className="p-4 space-y-4">
        {/* User Info Card */}
        <motion.div
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-gradient-to-br from-primary-500 to-primary-600 rounded-2xl p-6 text-white text-center"
        >
          <div className="w-20 h-20 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
            <User size={40} className="text-white" />
          </div>
          <h2 className="text-xl font-bold">{user?.name}</h2>
          <p className="text-primary-200 text-sm mt-1">{user?.email}</p>
        </motion.div>

        {/* Account Details */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.1 }}
          className="bg-white rounded-xl p-4 space-y-4"
        >
          <h3 className="font-semibold text-gray-900">Account Details</h3>
          
          <div className="flex items-center gap-3 text-gray-600">
            <Mail className="w-5 h-5 text-primary-500" />
            <div className="flex-1">
              <p className="text-xs text-gray-500">Email</p>
              <p className="text-sm font-medium text-gray-900">{user?.email}</p>
            </div>
          </div>

          <div className="flex items-center gap-3 text-gray-600">
            <Building2 className="w-5 h-5 text-primary-500" />
            <div className="flex-1">
              <p className="text-xs text-gray-500">Agency</p>
              <p className="text-sm font-medium text-gray-900">{user?.agencyName}</p>
            </div>
          </div>

          <div className="flex items-center gap-3 text-gray-600">
            <Shield className="w-5 h-5 text-primary-500" />
            <div className="flex-1">
              <p className="text-xs text-gray-500">Agent ID</p>
              <p className="text-sm font-medium text-gray-900">#{user?.agencyId}</p>
            </div>
          </div>
        </motion.div>

        {/* Menu Items */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="bg-white rounded-xl overflow-hidden"
        >
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={item.action}
              className="w-full flex items-center gap-3 p-4 hover:bg-gray-50 active:bg-gray-100 transition-colors border-b border-gray-100 last:border-0"
            >
              <item.icon className="w-5 h-5 text-gray-600" />
              <span className="flex-1 text-left text-gray-900">{item.label}</span>
              <ChevronRight className="w-5 h-5 text-gray-400" />
            </button>
          ))}
        </motion.div>

        {/* Logout Button */}
        <motion.button
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3 }}
          onClick={handleLogout}
          className="w-full flex items-center justify-center gap-2 py-3 bg-red-500 text-white rounded-xl font-medium"
        >
          <LogOut size={20} />
          Logout
        </motion.button>

        {/* Version */}
        <p className="text-center text-xs text-gray-400 mt-4">
          JetNova Agent Portal v1.0
        </p>
      </div>

      <BottomNav activeTab="profile" />
    </div>
  )
}

export default Profile

